import React, { useEffect, useState } from "react";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function Dashboard10() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState("");

  console.log(count);
  useEffect(() => {
    const token = sessionStorage.getItem("tokenclassx");

    if (!token) {
      navigate("/class-x");
      return;
    }

    fetch(`${config.API_BASE_URL}/PrincipalDashBoardCount_CL10`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          throw new Error("Failed to fetch dashboard data");
        }
        return response.json();
      })
      .then((data) => {
        setLoading(false);
        console.log("Dashboard data:", data);
        setCount(data.data.dashboardCount_list);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  }, [navigate]);

  return (
    <>
      <div class="container-scroller">
        <Navbar10 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar10 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="row">
                    <div class="col-12 col-xl-12 mb-4 mb-xl-0">
                      <h3
                        class="font-weight-bold"
                        style={{ textTransform: "uppercase" }}
                      >
                        Welcome Principal
                      </h3>
                      <h6
                        class="font-weight-normal mb-2"
                        style={{ textTransform: "uppercase" }}
                      >
                        School Code: {sessionStorage.getItem("schoolCode")}
                      </h6>
                      <h6 class="font-weight-normal mb-0">
                        {sessionStorage.getItem("schoolname")}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                    href="#"
                    className="card card-success"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-total-registration");
                    }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div
                          className="col-md-6"
                          style={{ borderRight: "1px solid #FFFFFF" }}
                        >
                          <h3 className="mb-2">
                            Total <br />
                            <small className="card-text">Count</small>
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count.totaL_APPLICANTS || "0"}
                          </p>
                        </div>
                        <div className="col-md-6" style={{ fontWeight: 600 }}>
                          <p className="fs-10 mb-2 mt-1">
                            Private:{" "}
                            {`${count.private || ""}/${
                              count.totaL_COUNT_PRIVATE || ""
                            }` || "0"}
                          </p>
                          <p className="fs-10 mb-2 mt-1">
                            Regular:{" "}
                            {`${count.regular || ""}/${
                              count.totaL_COUNT_REGULAR || ""
                            }` || "0"}
                          </p>
                          <p className="fs-10 mb-2 mt-1">
                            Ex-regular:{" "}
                            {`${count.eX_REGULAR || ""}/${
                              count.totaL_COUNT_EX_REGULAR || ""
                            }` || "0"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span
                        className="small-box-footer"
                        style={{ textDecoration: "none" }}
                      >
                        Print Checklist
                      </span>
                    </div>
                  </a>
                </div>

                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                     onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-checklist-generated");
                    }}
                    href="#"
                    className="card card-dark-blue"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h3 className="mb-2">
                            Checklist <br />
                            <small className="card-text">Generated</small>
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count.checklisT_GENERATED || "0"}
                          </p>
                        </div>
                        <div class="col-md-4" style={{ textAlign: "center" }}>
                          <i
                            class="fa fa-list icon-large"
                            style={{ fontSize: "40px" }}
                          ></i>
                        </div>
                      </div>
                    </div>
                    {/* <div>
                      <span
                        className="small-box-footer"
                        style={{ textDecoration: "none" }}
                      >
                        Submit to DEO
                      </span>
                    </div> */}
                  </a>
                </div>

                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                    href="#"
                    className="card card-orange"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-generate-challan");
                    }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h3 className="mb-2">
                            Challan <br />
                            <small className="card-text">Generate</small>
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count.pendinG_FOR_CHALLAN_GENERATION || "0"}
                          </p>
                        </div>
                        <div class="col-md-4" style={{ textAlign: "center" }}>
                          <i
                            class="fa fa-clock-o  icon-large"
                            style={{ fontSize: "40px" }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                    href="#"
                    className="card card-dark-danger"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-challan-status");
                    }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h3 className="mb-2">
                            Challan <br />
                            <small className="card-text">Status</small>
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count.generateD_CHALLAN_STATUS || "0"}
                          </p>
                        </div>
                        <div class="col-md-4" style={{ textAlign: "center" }}>
                          <i
                            class="fa fa-clipboard  icon-large"
                            style={{ fontSize: "40px" }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                    href="#"
                    className="card card-tale"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/class-x-consolidated-checklist");
                    }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          <h3 className="mb-2">
                            List of <br />
                            <small className="card-text">Examinees</small>
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count.consolidateD_STATEMENT || "0"}
                          </p>
                        </div>
                        <div class="col-md-4" style={{ textAlign: "center" }}>
                          <i
                            class="fa fa-download icon-large"
                            style={{ fontSize: "40px" }}
                          ></i>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-m-4 col-xl-3 mb-4 stretch-card transparent">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className="card card-light-danger"
                    style={{ textDecoration: "none", pointerEvents: "none" }}
                  >
                    <div className="card-body">
                      <div className="row">
                        <div
                          className="col-md-6"
                          style={{ borderRight: "1px solid #FFFFFF" }}
                        >
                          <h3 className="mb-2">
                            Challan <br />
                            Limit
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count?.challaN_LIMIT_CL_10 || "0"}
                          </p>
                        </div>
                        <div className="col-md-6" style={{ fontWeight: 600 }}>
                          <h3 className="mb-2">
                            Challan <br />
                            Left
                          </h3>
                          <p className="fs-30 mb-2 mt-4">
                            {count?.challaN_LEFT_CL_10 || "0"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <Footer10 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard10;
